import React from "react";
import PropTypes from "prop-types";
import { Image } from "@sparefoot/react-commons";
import { H1 } from "components/core/Typography";
import SearchBar from "components/search/SearchBar/SearchBar";
import StickySearchHeader from "components/organisms/StickySearchHeader";
import HeaderBackgroundDesktop from "assets/images/psp/hero/storage-101-hero.webp";
import HeaderBackgroundMobile from "assets/images/psp/hero/storage-101-header-mobile.webp";
import HeaderBackgroundTablet from "assets/images/psp/hero/storage-101-header-tablet.webp";
import "./StorageHero.scss";
import Container from "components/core/Page/Container";
import PSPMarkdownContent from "components/molecules/PSPMarkdown/PSPMarkdownContent";

function StorageHero({
	title,
	description,
	buttonText,
	heroImages = {
		desktop: HeaderBackgroundDesktop,
		tablet: HeaderBackgroundTablet,
		mobile: HeaderBackgroundMobile
	},
	heroAltText = "Storage Hero Image",
	searchPlaceholder = "Search by city, state, or zip..."
}) {
	const additionalProps = {
		paragraph: {
			size: "standard",
			color: "white"
		},
		anchor: {
			color: "white",
			style: { textDecoration: "underline", fontWeight: "bold" }
		}
	};

	return (
		<div
			className="storage-hero-container"
			id="storage-hero-container"
		>
			<Container>
				{/* Responsive Background Images */}
				<picture className="storage-hero__background">
					<source
						media="(min-width: 1272px)"
						srcSet={heroImages.desktop}
					/>
					<source
						media="(min-width: 768px)"
						srcSet={heroImages.tablet}
					/>
					<Image
						src={heroImages.mobile}
						alt={heroAltText}
						className="storage-hero__background-img"
					/>
				</picture>

				{/* Content Section */}
				<div className="storage-hero-content">
					<div className="storage-hero__textarea">
						<H1 className="storage-hero__title">{title}</H1>
						{description && (
							<div className="storage-hero__description">
								<PSPMarkdownContent
									content={description}
									additionalProps={{ ...additionalProps }}
								/>
							</div>
						)}
					</div>
					<SearchBar
						id="psp-hero-search"
						label={searchPlaceholder}
						buttonText={buttonText}
						theme="plainBlue"
						className="storage-hero__search"
					/>
				</div>
				<StickySearchHeader triggerId="storage-hero-container" />
			</Container>
		</div>
	);
}

StorageHero.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string,
	buttonText: PropTypes.string.isRequired,
	heroImages: PropTypes.shape({
		desktop: PropTypes.string,
		tablet: PropTypes.string,
		mobile: PropTypes.string
	}),
	heroAltText: PropTypes.string,
	searchPlaceholder: PropTypes.string
};

export default StorageHero;
